(function($) {

    if ($('.page-template-template-search').length) {
        var searchBox = $('.search-box.search-box-page');
        var searchBoxInput = searchBox.find('input');
        var inputValue = searchBoxInput[0].value;
        var searchBoxBtn = searchBox.find('.button');
        var resultsSection = $('.search-results');
        var searchLoader = resultsSection.find('.loader');
        var resultsList = resultsSection.find('.results-list');
        var noResultsNotice = resultsSection.find('.no-results-notice');
        var searchNavigation = $('.search-navigation li');
        var searchNavigationCounters = searchNavigation.find('.count-wrap');

        searchBoxInput.on('change, keyup', function() {
            inputValue = searchBoxInput[0].value;
            var queryLength = inputValue.length;

            if (queryLength > 2) {
                searchBoxBtn.attr('data-disabled', 'false');
            } else {
                searchBoxBtn.attr('data-disabled', 'true');
            }
        });

        searchBoxBtn.on('click', function() {
            if (inputValue) {
                searchLoader.addClass('active');
                noResultsNotice.removeClass('active');
                searchNavigationCounters.addClass('hidden');
                resultsList.empty();

                $.ajax({
                    url: postmpwp.home_url +  "?s=" + inputValue,
                    type: "GET",
                    dataType: "json",
                    success: function(response) {
                        searchLoader.removeClass('active');

                        if (response.items.length) {
                            response.items.forEach(function(item) {
                                searchNavigation.filter('[data-category="Naujienos"]').find('.count-number').text(response.articlesCount);
                                searchNavigation.filter('[data-category="Komentarai"]').find('.count-number').text(response.commentsCount);
                                searchNavigationCounters.removeClass('hidden');
                                resultsList.append(JSON.parse(item));
                            });
                        }
                        else {
                            noResultsNotice.addClass('active');
                        }

                    }
                });
            }
        });

        $(window).on('load', function() {
            if (inputValue.length > 0) {
                searchBoxBtn.click();
            }
        })

        searchNavigation.on('click', function() {
            var targetElement = $(this).data('category');

            $([document.documentElement, document.body]).animate({
                scrollTop: $('.articles-section[data-category="'+targetElement+'"]').offset().top - $('header').outerHeight()
            }, 600);
        })
    }

})( jQuery );